import type {
	ResponsiveProductCardSettings,
	ScreenSize,
} from 'product-card/context/ProductCardConsumerLayoutContext/ProductCardConsumerLayoutContext'
import type { View } from 'product-list/types/View'

export function applyMobileAbTestSettings(
	settings: Record<View, ResponsiveProductCardSettings>
) {
	const { inspirational, standard } = settings
	const sizesToUpdate = ['small', 'medium'] as ScreenSize[]

	for (const size of sizesToUpdate) {
		inspirational[size] = {
			...inspirational[size],
			hasSizeSheetButton: true,
			hasGroupedColorsSelector: true,
		}

		standard[size] = {
			...standard[size],
			hasGroupedColorsSelector: true,
			shouldRenderColorSheetButton: true,
			shouldRenderLinkLabels: false,
			hasColorPicker: false,
		}
	}
}
